import * as React from "react";
const SvgGruppen1 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Gruppen1">
    <rect x={73.09} y={182.58} fill="currentColor" rx={7.5} ry={7.5} />
    <circle cx={53.27} cy={190.08} r={9.17} fill="currentColor" />
    <path
      fill="currentColor"
      d="M139.79 226.42H31.27a8.61 8.61 0 0 1-8.61-8.61v-55.44a8.61 8.61 0 0 1 8.61-8.61h108.52a8.61 8.61 0 0 1 8.61 8.61v55.44a8.61 8.61 0 0 1-8.61 8.61m-102.13-15h95.75v-42.67H37.66zM179.05 96.98V32.23c0-2.19-1.77-3.96-3.96-3.96H68.14c-2.19 0-3.96 1.77-3.96 3.96v64.75c0 2.19 1.77 3.96 3.96 3.96h27.03l-3.92 11.72h-5.92c-2.19 0-3.96 1.77-3.96 3.96v7.08c0 2.19 1.77 3.96 3.96 3.96h72.56c2.19 0 3.96-1.77 3.96-3.96v-7.08c0-2.19-1.77-3.96-3.96-3.96h-5.92l-3.92-11.72h27.03c2.19 0 3.96-1.77 3.96-3.96ZM79.18 43.27h84.87v42.67H79.18zm56.98 69.39h-29.09l3.92-11.72h21.24l3.92 11.72Z"
    />
    <path
      fill="currentColor"
      d="M142.7 54.97v12.2h-13.59v-4.55a7.46 7.46 0 0 0-7.46-7.46h-.09a7.46 7.46 0 0 0-7.46 7.46v4.55h-13.59a7.46 7.46 0 0 0-7.46-7.46h-.09a7.46 7.46 0 0 0-7.46 7.46v11.27a3.73 3.73 0 0 0 3.73 3.73h64.72a3.73 3.73 0 0 0 3.73-3.73V54.97a7.46 7.46 0 0 0-7.46-7.46h-.09a7.46 7.46 0 0 0-7.46 7.46ZM233.85 152.17V98.04c0-11.07-9.01-20.08-20.08-20.08s-20.08 9.01-20.08 20.08v54.13a34.62 34.62 0 0 0-14.64 28.33c0 19.14 15.58 34.72 34.72 34.72s34.72-15.57 34.72-34.72c0-11.39-5.51-21.87-14.64-28.33m-20.08 48.05c-10.87 0-19.72-8.85-19.72-19.72 0-7.38 4.07-14.08 10.61-17.5l4-2.09.03-4.55V98.04c0-2.8 2.28-5.08 5.08-5.08s5.08 2.28 5.08 5.08v62.86l4.03 2.1c6.54 3.42 10.61 10.12 10.61 17.5 0 10.87-8.85 19.72-19.72 19.72"
    />
    <circle
      cx={213.77}
      cy={180.5}
      r={9.58}
      fill="currentColor"
      transform="rotate(-9.22 213.691 180.438)"
    />
  </svg>
);
export default SvgGruppen1;
